import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import Dropzone from 'react-dropzone'
import FormData from 'form-data'
import ChatMessage from './ChatMessage'
import PinnedMessages from './PinnedMessages'
import * as actions from '../../../actions'
import { Headers } from '../../../helpers'
import { apiUrl } from '../../../config/settings'
import InputTrigger from 'react-input-trigger'
import Suggestor from './Suggestor'
import scrollIntoView from 'scroll-into-view-if-needed'

import JSEMOJI from 'emoji-js'
import { Picker } from 'emoji-mart'
import 'emoji-mart/css/emoji-mart.css'

import './styles.css'

let jsemoji = new JSEMOJI()
jsemoji.img_set = 'emojione'
jsemoji.img_sets.emojione.path = 'https://cdn.jsdelivr.net/emojione/assets/3.0/png/32/'

class ChatSession extends Component {
  constructor (props) {
    super(props)

    this.state = {
      message: '',
      accept: '',
      dropzoneActive: false,
      suggestor: {
        top: '0px',
        left: '0px'
      },
      displaySuggestions: false,
      mentions: [],
      progress: 0,
      displayProgress: false,
      scrolling: false,
      scrollToMessage: '',
      showEmojiPicker: false
    }

    this.sendMessage = this.sendMessage.bind(this)
    this.handleFileUpload = this.handleFileUpload.bind(this)
    this.onDragEnter = this.onDragEnter.bind(this)
    this.onDragLeave = this.onDragLeave.bind(this)
    this.onScrollToTop = this.onScrollToTop.bind(this)
    // this.highlightHandleTags = this.highlightHandleTags.bind(this)
    this.handleEmojiClick = this.handleEmojiClick.bind(this)
  }

  handleFileUpload (files) {
    this.setState({ dropzoneActive: false })
    files.forEach(file => {
      if (file.size > 5 * 1024 * 1024) {
        this.props.dispatch(actions.displayAlert('Max file size: 5mb'))
        return
      }

      let data = new FormData()
      data.append('file', file)
      data.append('from', this.props.me)
      data.append('session', this.props.session._id)

      const options = {
        headers: Headers.getWithAuth(),
        onUploadProgress: (progressEvent) => {
          let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          this.setState({ progress: percentCompleted, displayProgress: true })
        }
      }

      axios
        .post(`${apiUrl}/files/upload`, data, options)
        .then(res => {
          if (res.data.success) {
            this.setState({ progress: 0, displayProgress: false })
          }
        })
    })
  }

  onDragEnter () {
    this.setState({
      dropzoneActive: true
    })
  }

  onDragLeave () {
    this.setState({
      dropzoneActive: false
    })
  }

  sendMessage (ev) {
    if (ev) ev.preventDefault()
    if (this.state.message !== '') {
      const action = 'new_message'
      const data = {
        session: this.props.session._id,
        from: this.props.me,
        to: this.props.session.participants.filter(p => p !== this.props.me),
        text: this.state.message,
        mentions: this.state.mentions
      }

      this.props.dispatch(actions.socketSendMessage({ action, data }))
      this.setState({ ...this.state, message: '', mentions: [], showEmojiPicker: false })
    }
  }

  componentDidMount () {
    setTimeout(this.scrollToBottom.bind(this), 0)
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.displaySuggestions && !this.state.displaySuggestions) {
      this.props.dispatch(actions.clearMentions())
    }
    if (this.state.scrollToMessage) {
      let elm = document.getElementById(this.state.scrollToMessage)
      setTimeout(() => {
        scrollIntoView(elm, { behavior: 'smooth', scrollMode: 'if-needed', inline: 'start', block: 'start' })
      }, 200)
      this.setState({ scrollToMessage: '' })
    } else {
      !this.state.scrolling && this.scrollToBottom()
    }
  }

  scrollToBottom () {
    const { scroll } = this.refs
    if (scroll) {
      scroll.scrollTop = scroll.scrollHeight - scroll.clientHeight
    }
  }

  checkButtonsArea (event) {
    if (event.which === 13 && !event.shiftKey && !this.state.displaySuggestions) {
      event.preventDefault()
      this.sendMessage()
    }
  }

  handleAreaChange (event) {
    this.setState({ message: event.target.value })
  }

  renderMessage (msg) {
    let mentionRegex = RegExp('@[a-z]+', 'gmi')
    let matches = msg.match(mentionRegex)
    let messageParts = msg.split(mentionRegex)
    if (!matches) {
      return msg
    } else {
      return (
        <div>
          {messageParts.map((p, index) => {
            return (
              <span key={index}>
                {p}
                {matches[index] && (
                  <span className='red'>{matches[index]}</span>
                )}
              </span>
            )
          })}
        </div>
      )
    }
  }

  onScroll (ev) {
    ev.target.scrollTop === 0 && this.onScrollToTop(ev)
    this.setState({ scrolling: ev.target.scrollHeight - (parseInt(ev.target.clientHeight, 10) + parseInt(ev.target.scrollTop, 10)) >= 2 })
  }

  onScrollToTop (ev) {
    if (ev.target.scrollTop === 0 && this.props.session.msg.length > 29) {
      this.setState({ scrollToMessage: this.props.session.msg[0]._id })
      const action = 'load_more_msgs'
      const data = {
        session: this.props.session.id,
        skip: this.props.session.msg.length
      }
      this.props.dispatch(actions.socketSendMessage({ action, data }))
    }
  }

  handleEmojiClick (emoji) {
    let emojiPic = jsemoji.replace_colons(emoji.colons)
    this.setState({ message: this.state.message + emojiPic })
  }

  render () {
    const keyCode = navigator.platform.includes('Linux') ? 229 : 50
    const pcUser = !(navigator.platform.includes('iPhone') || navigator.platform.includes('Linux'))

    return (
      <Dropzone
        disableClick
        style={{ position: 'relative' }}
        accept={this.state.accept}
        onDrop={this.handleFileUpload}
        onDragEnter={this.onDragEnter}
        onDragLeave={this.onDragLeave}>
        {this.state.dropzoneActive && <div className='chat-dropzone'>Drop files...</div>}
        <PinnedMessages msgs={this.props.session.msg} />
        <div className='y-scroll-wrap chat-field'>
          <div className='y-scroll' ref={'scroll'} onScroll={this.onScroll.bind(this)}>
            <div className='chat-tabs-content'>
              <div className='chat-general-tab'>
                {this.props.session.msg && this.props.session.msg.map(msg => <ChatMessage key={msg._id} msg={msg} />)}
              </div>
            </div>
          </div>
        </div>
        <div className='chat-message'>
          <div>
            {this.state.showEmojiPicker &&
              <Picker
                // set='emojione'
                onSelect={emoji => this.setState({ message: this.state.message + ` ${emoji.native} ` })}
                // onSelect={this.handleEmojiClick}
                showSkinTones={false}
                title='Pick your emoji…'
                emoji='point_up' />
            }
            <form name='chat-message' onSubmit={this.sendMessage}>
              {pcUser &&
                <span
                  onClick={() => this.setState({ showEmojiPicker: !this.state.showEmojiPicker })}
                  className='emoji-triger'>☺</span>
              }
              {this.state.displayProgress &&
                <div className='progress-bar' style={{ width: `${this.state.progress}%` }}>{this.state.progress}%</div>}
              <Suggestor
                textValue={this.state.message}
                searchText={this.state.suggetionText}
                show={this.state.displaySuggestions}
                cursor={this.state.suggestor}
                onSuggetionSelect={(text, suggentionDetails) => {
                  let newMentions = this.state.mentions.slice(0)
                  newMentions.push(suggentionDetails.participantId)
                  this.setState({ message: text + ' ', displaySuggestions: false, mentions: newMentions })
                  this.endHandler()
                }}
              >
                <InputTrigger
                  trigger={{
                    keyCode: keyCode,
                    shiftKey: pcUser
                  }}
                  onStart={(obj) => { this.setState({ displaySuggestions: true, suggestor: obj.cursor, suggetionText: '' }) }}
                  onCancel={(obj) => { this.setState({ displaySuggestions: false, suggetionText: '' }) }}
                  onType={(obj) => { this.setState({ suggetionText: obj.text }) }}
                  endTrigger={(endHandler) => { this.endHandler = endHandler }}
                >
                  <textarea
                    placeholder='Start typing your message or drop file'
                    className='chat-message'
                    value={this.state.message}
                    onFocus={() => this.setState({ showEmojiPicker: false })}
                    onKeyDown={this.checkButtonsArea.bind(this)}
                    onChange={this.handleAreaChange.bind(this)} />
                </InputTrigger>
                <div className='bttn' style={{ background: 'none' }}>
                  <button
                    className='chat-message-send'
                    onClick={this.sendMessage}><img alt='' src='/imgs/icon-chat-send.png' /></button>
                </div>
              </Suggestor>
            </form>
          </div>
        </div>
      </Dropzone>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    me: state.auth.user.participantId,
    handle: state.auth.user.handle,
    players: state.participants
  }
}

export default connect(mapStateToProps)(ChatSession)



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/ChatSession.js